import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum TrashEntityTypeEnum {
    ADDRESS_BOOK_CONTACT = 'ContactModel',
    ANAMNESIS = 'AnamnesisModel',
    BASIC_SOCIAL_CONSULTING = 'BasicSocialConsultingModel',
    BILLING = 'BillingModel',
    CALENDAR_ITEM = 'CalendarItemModel',
    CARE_PAYMENT = 'CarePaymentModel',
    DIET_ORDER = 'DietOrderModel',
    CARE_PLAN = 'CarePlanModel',
    EPICRISIS = 'EpicrisisModel',
    FILE = 'FileModel',
    FOLDER = 'FolderModel',
    FOLDER_CONTRACT = 'FolderContractModel',
    FOLDER_FORM = 'FolderFormModel',
    FOLDER_FORM_DATA = 'FolderFormDataModel',
    FOLDER_INDIVIDUAL_PLAN = 'FolderIndividualPlanModel',
    FOLDER_MEDICAL_REPORT = 'FolderMedicalReportModel',
    FOLDER_MEDICATION = 'FolderMedicationModel',
    FOLDER_NOTE = 'FolderNoteModel',
    PERSON_CONTACT = 'PersonContactModel',
    PLATFORM_BILLING_CONTRACT = 'PlatformBillingServiceContractModel',
    PLATFORM_BILLING_BASIS = 'PlatformBillingBasisModel',
    SERVICE = 'ServiceModel',
    SERVICE_MAIL = 'ServiceMailsModel',
    SERVICE_GROUP = 'ServiceGroupModel',
    SERVICE_MEDICAL_PROCEDURE = 'ServiceMedicalProcedureModel',
    SERVICE_NURSING_CARE_DIAGNOSIS_CODE = 'ServiceNursingCareDiagnosisCodeModel',
    SERVICE_PATTERN = 'ServicePatternModel',
    SERVICE_PAYMENT = 'ServicePaymentModel',
    SOCIAL_BILLING_RECEIPT = 'SocialBillingReceiptModel',
    SOCIAL_BILLING_DOCUMENT = 'SocialBillingDocumentModel',
    SOCIAL_FINANCIAL_DEPOSIT = 'SocialFinancialDepositModel',
    SOCIAL_PAYMENT = 'SocialPaymentModel',
    MESSAGE = 'MessageModel',
    USER_TASK = 'UserTaskModel',
    VOUCHER = 'VoucherModel',
    WAITING_LIST = 'WaitingListModel',
    WAITING_LIST_RATING = 'WaitingListRatingModel',
    WAREHOUSE_MATERIAL_OPERATION = 'WarehouseMaterialOperationModel',
    WORK = 'WorkModel',
}

export const trashEntityTypeEnumOptions = enumToOptions(
    TrashEntityTypeEnum,
    'entities.',
);
